import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  showCustomSearch: false,
  modalData: {
    auctionType: "",
    currentPrice: 0,
    vehicleId: "",
  },
};

const ModalsSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    setIsGlobalModalOpen: (state, action) => {
      state.isOpen = action.payload;
    },
    setModalData: (state, action) => {
      state.modalData = action.payload;
    },
    setShowCustomSearch: (state, action) => {
      state.showCustomSearch = !state.showCustomSearch;
    },
  },
});
export const { setIsGlobalModalOpen, setModalData, setShowCustomSearch } = ModalsSlice.actions;
export default ModalsSlice.reducer;
